import {
	ComplaintSystemSchema,
	type ComplaintSystemEntry,
} from '#app/routes/mocra+/_form+/adverse-events/form.ts'
import {
	collectAeSystemErrors,
	createAeSystemDraft,
	aeSystemDraftToEntry,
	aeSystemEntryToDraft,
	sanitizeAeSystemDraft,
	type AeSystemDraft,
} from '#app/routes/mocra+/_form+/components/ae-systems/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const aeSystemDefinition = assertEntityDefinition<
	ComplaintSystemEntry,
	AeSystemDraft
>({
	schema: ComplaintSystemSchema,
	createDraft: () => createAeSystemDraft(),
	sanitizeDraft: sanitizeAeSystemDraft,
	serialize: aeSystemDraftToEntry,
	deserialize: aeSystemEntryToDraft,
	collectErrors: collectAeSystemErrors,
})

export type AeSystemEntityDraft = AeSystemDraft
